// @flow

import gql from 'graphql-tag';

import { useQuery } from '@apollo/react-hooks';

import type { OperationVariables } from '@apollo/react-common';

type AccountId = number;
type PlanId = number;

type Account = {
  id: AccountId,
  name: string,
  plan: {
    id: PlanId,
    amount: number,
    name: string,
  },
  usage: {
    periodEnd: string,
    tasks: {
      limit: number,
      total: number,
    },
    zaps: {
      limit: number,
      total: number,
    },
  },
};

type SidebarQueryVariables = {
  accountId: AccountId,
};

type SidebarQueryResponse = {
  isAuthenticatedV2: boolean,
  account: Account,
};

type Arguments = {
  accountId: AccountId,
};

type Result = {
  ...$Exact<OperationVariables>,
  data: SidebarQueryResponse,
};

export const sidebarDataQuery = gql`
  query sidebarDataQuery($accountId: Int!) {
    isAuthenticatedV2
    account(id: $accountId) {
      id
      name
      plan {
        amount
        hasMeteredBilling
        name
        id
        tiers {
          numTasks
          pricePerTask
        }
      }
      usage {
        periodEnd
        tasks {
          limit
          total
        }
        zaps {
          limit
          on
        }
      }
    }
  }
`;

/**
 * Hook that provides data used for the global navigation.
 */
const useSidebarData = ({ accountId }: Arguments): Result => {
  const variables: SidebarQueryVariables = {
    accountId,
  };

  const result: Result = useQuery(sidebarDataQuery, { ssr: false, variables });

  return result;
};

export default useSidebarData;
